<script setup>
import {computed} from "vue";

const {flow, hasIcon} = defineProps({
  flow: Object,
  hasIcon: {
    type: Boolean,
    default: false
  }
})

const statusClass = computed(() => {
  switch (flow.flag) {
    case 1:
      return 'paused'
    case 2:
      return 'stopped'
    case 3:
      return 'archived'
    default:
      return 'ok'
  }
})

const icon = computed(() => statusClass === 'ok' ? '#ok-icon' : '#warning-icon')
</script>
<template>
  <button class="text-center tile-button" :class="statusClass">
    <svg v-if="hasIcon" class="icon">
      <use :xlink:href="icon"></use>
    </svg>
  </button>
</template>
